<template>
  <div>
    <div v-if="type === 'by-law'">
      <review-question-bylaw-item
        :hide-change-links="hideChangeLinks"
        :question="question"
        :question-id="questionId"
      ></review-question-bylaw-item>
    </div>

    <div v-else-if="type === 'director-removals'">
      <review-question-removal-item
        :hide-change-links="hideChangeLinks"
        :question="question"
        :question-id="questionId"
        :type="type"
        :is-resident="isResident"
      ></review-question-removal-item>
    </div>

    <div v-else>
      <review-question-election-item
        :hide-change-links="hideChangeLinks"
        :question="question"
        :question-id="questionId"
        :type="type"
        :is-resident="isResident"
      ></review-question-election-item>
    </div>
  </div>
</template>

<script>
import ReviewQuestionElectionItem from './ReviewQuestionElectionItem.vue';
import ReviewQuestionBylawItem from './ReviewQuestionBylawItem.vue';
import ReviewQuestionRemovalItem from './ReviewQuestionRemovalItem';

export default {
  components: {
    ReviewQuestionBylawItem,
    ReviewQuestionElectionItem,
    ReviewQuestionRemovalItem
  },
  props: {
    question: {
      type: Object,
      required: true
    },
    questionId: {
      type: Number,
      required: true
    },
    isResident: {
      type: Boolean
    },
    hideChangeLinks: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    type() {
      return this.question.type;
    }
  }
};
</script>
